import { client } from '@/api/http';
import { type AxiosRequestConfig, type AxiosResponse, HttpStatusCode } from 'axios';
import { errorDetail } from '@/api/errorDetail';
import { AppError } from '@/stores/appErrorStore';

export interface HipSpineStudyBounds {
    min_cup_anteversion_bound: number;
    max_cup_anteversion_bound: number;
    min_cup_inclination_bound: number;
    max_cup_inclination_bound: number;
}

export type HipSpineStudyState = 'Created' | 'Processing' | 'Completed' | 'Error';

export type HipSpineStudyApiObject = {
    id: number;
    resource_state: HipSpineStudyState;
    min_cup_anteversion_bound: number;
    max_cup_anteversion_bound: number;
    min_cup_inclination_bound: number;
    max_cup_inclination_bound: number;
};

/** Fetch hip spine study for a case */
export async function getHipSpineStudy(
    caseId: number,
    hipSpineStudyId: number,
    config?: AxiosRequestConfig,
): Promise<HipSpineStudyApiObject> {
    const { status, data }: AxiosResponse = await client.get<HipSpineStudyApiObject>(
        `cases/${caseId}/hip-spine-studies/${hipSpineStudyId}`,
        config,
    );

    if (status === HttpStatusCode.Ok) {
        return data;
    } else if (status === HttpStatusCode.NotFound || status === HttpStatusCode.Forbidden) {
        throw new AppError(
            'Hip Spine study not found' + errorDetail(data),
            'This Hip Spine study does not exist or you do not have permission to view it.',
        );
    }

    throw new Error(`Failed to get hip spine study` + errorDetail(data));
}

export async function putHipSpineStudy(
    caseId: number,
    studyId: number,
    bounds: HipSpineStudyBounds,
): Promise<HipSpineStudyApiObject> {
    const { status, data }: AxiosResponse = await client.put(
        `cases/${caseId}/hip-spine-studies/${studyId}`,
        bounds,
    );

    if (status === HttpStatusCode.Ok) {
        return data;
    }

    throw new Error('Failed to update hip spine study' + errorDetail(data));
}
